export const AccessReportRouting = [
  {
    path: "/report-center/download/access-report/list",
    name: "material-access-report-list",
    meta: { title: "材料出入库汇总表" },
    component: () =>
      import(
        /* webpackChunkName: "access-report" */ "@/views/report-center/access-report/list/index.vue"
      ),
  },
];
